<template>
  <div style="background: #fff">
    <v-card
      class="d-flex justify-center align-center mb-6"
      :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'"
      flat
      tile
      height="100vh"
      v-if="!is_complete"
    >
      <v-layout align-center justify-center row fill-height>
        <v-img
          src="../../img/JuntosLoading.gif"
          max-height="64"
          max-width="64"
        />
      </v-layout>
    </v-card>
    <div v-if="is_complete">
      <v-flex xs12 sm12 md12 v-if="is_complete">
        <Header />
        <v-layout>
          <v-container fluid>
            <v-layout row wrap fluid>
              <v-flex xs12 sm6 offset-sm3 v-if="overdueTotal > 1">
                <v-card>
                  <v-img
                    src="../../img/negociacao.jpg"
                    aspect-ratio="2.75"
                    position="bottom center"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h5 class="title font-weight-bold mb-0">
                        Negocie suas dívidas
                      </h5>
                      <div>
                        <span class="red--text"
                          >Identificamos que você possui
                          <span class="font-weight-bold"
                            >R$ {{ overdueTotal | formatCurrency }}</span
                          >
                          em débitos exclusivamente com a Juntos Energia
                        </span>
                        e sabemos que todo mundo precisa de um alívio, por isso,
                        queremos ajudar você a organizar suas contas.
                        <br /><span class="text-danger caption"
                          >* Este valor não contempla valores em aberto com a
                          concessionária.</span
                        >
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn
                      dark
                      block
                      color="indigo darken-2"
                      @click="parcelDialog = true"
                      >Negocie sua dívida</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex class="pa-3" xs12 sm12 v-if="overdueTotal > 0"></v-flex>
              <v-flex xs12 sm12>
                <v-card class="grey darken-1 white--text pa-4">
                  <v-flex xs12 sm12>
                    <v-combobox
                      v-model="consumerUnit"
                      :items="consumer_units"
                      item-value="id"
                      item-text="id"
                      label="Selecione o seu Imóvel"
                      outlined
                      dense
                      auto-select-first
                      autofocus
                      dark
                      :disabled="consumer_units && consumer_units.length <= 1"
                      @change="getBillings(currentUser.id, consumerUnit.id)"
                    ></v-combobox>
                  </v-flex>
                  <v-flex
                    xs12
                    v-if="
                      consumerUnit &&
                      consumerUnit.address &&
                      consumerUnit.address.address
                    "
                  >
                    <div>
                      Endereço: {{ consumerUnit.address.address }},
                      {{ consumerUnit.address.address_number }}.
                      {{ consumerUnit.address.city }}-{{
                        consumerUnit.address.state.initials
                      }}
                    </div>
                    <div>CEP: {{ consumerUnit.address.postal_code }}</div>
                  </v-flex>
                  <v-layout row wrap>
                    <v-flex xs12 md3 v-if="consumerUnit && consumerUnit.status">
                      <v-chip
                        class="ma-2 pa-0 white--text"
                        :color="consumerUnit.status | formatUCStatusColor"
                      >
                        {{ consumerUnit.status | formatUCStatus }}
                      </v-chip>
                    </v-flex>
                    <v-spacer />
                    <v-flex
                      xs12
                      md3
                      v-if="consumerUnit && consumerUnit.account_balance"
                    >
                      <v-chip class="ma-2 pa-0 white--text" color="green">
                        Bônus da Unidade Consumidora: R$
                        {{ consumerUnit.account_balance | formatCurrency }}
                      </v-chip>
                      <v-spacer />
                    </v-flex>
                    <v-flex xs12 md3 v-if="consumerUnit">
                      <v-chip class="ma-2 pa-0 white--text" color="blue">
                        <div>
                          Contrato
                          <span
                            :class="
                              'font-weight-bold ' +
                              (consumerUnit &&
                              consumerUnit.constract_type === 'internal'
                                ? 'green--text'
                                : 'blue--text')
                            "
                          >
                            {{
                              consumerUnit.constract_type === "internal"
                                ? "online"
                                : "autentique"
                            }}
                          </span>
                          <v-btn
                            icon
                            ripple
                            @click="
                              downloadContracts(
                                consumerUnit.contract_url,
                                consumerUnit.id,
                              )
                            "
                            target="_blank"
                            v-if="
                              consumerUnit &&
                              consumerUnit.constract_type === 'internal'
                            "
                          >
                            <v-icon color="white">history_edu</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            ripple
                            :href="contract_id"
                            target="_blank"
                            v-else
                          >
                            <v-icon color="white">history_edu</v-icon>
                          </v-btn>
                        </div>
                      </v-chip>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <!-- Tabela começa aqui -->

              <v-flex xs12>
                <div class="header my-3">
                  <a
                    large
                    color="grey darken-1"
                    class="headlineButton"
                    @click="(changeTables(1), changeActiveHeader())"
                    :class="['header_link', { active: headerActive }]"
                  >
                    Minhas Faturas
                  </a>
                  <a
                    large
                    color="grey darken-1"
                    class="headlineButton"
                    @click="(changeTables(2), changeActiveHeader())"
                    :class="['header_link', { active: !headerActive }]"
                  >
                    Meus Acordos
                  </a>
                </div>

                <v-data-table
                  v-if="billingTable"
                  :headers="computedHeaders"
                  :items="billings"
                  :search="search"
                  :total-items="12"
                  hide-actions
                  no-data-text="Não há faturas"
                >
                  <template v-slot:items="props">
                    <td v-if="!$vuetify.breakpoint.mdAndDown">
                      {{ props.item.consumer_unit }}
                    </td>
                    <td>{{ props.item.competence | formatCompetenceTraco }}</td>
                    <td>{{ props.item.balance || 0 }}</td>
                    <td class="text-xs-right">
                      R$
                      {{
                        props.item.negotiation
                          ? props.item.negotiation.total_deal
                          : props.item.total | formatCurrency
                      }}
                    </td>
                    <td
                      v-if="!$vuetify.breakpoint.mdAndDown"
                      class="text-xs-right"
                    >
                      <div
                        v-if="
                          props.item.payment_service === 'pagarme' &&
                          props.item.transaction
                        "
                      >
                        {{
                          props.item.transaction &&
                          props.item.transaction.boleto_expiration_date
                            ? props.item.transaction.boleto_expiration_date
                            : "" | formatarDate
                        }}
                      </div>
                      <div
                        v-if="
                          props.item.payment_service === 'boletosimples' &&
                          props.item.transaction
                        "
                      >
                        {{
                          props.item.transaction &&
                          props.item.transaction.expire_at
                            ? props.item.transaction.expire_at
                            : ""
                        }}
                      </div>
                    </td>
                    <td
                      v-if="!$vuetify.breakpoint.mdAndDown"
                      class="text-xs-right"
                    >
                      <v-chip
                        class="ma-2 pa-0 white--text"
                        :color="props.item.status | formatStatusBillingColor"
                      >
                        {{ props.item.status | formatTransactionStatus }}
                      </v-chip>
                    </td>
                    <td v-else class="text-xs-right">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            :color="
                              props.item.status | formatStatusBillingColor
                            "
                            >{{ props.item.status | formatStatus }}</v-icon
                          >
                        </template>
                        <span>{{
                          props.item.status | formatTransactionStatus
                        }}</span>
                      </v-tooltip>
                    </td>
                    <td class="justify-center px-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-if="props.item?.transaction?.pix_qr_code"
                            @click="
                              copyPixCode(props.item.transaction.pix_qr_code)
                            "
                            v-on="on"
                            class="mx-0"
                            icon
                          >
                            <v-icon color="grey">{{
                              "pix_with_link" | formatPaymentTypeIcon
                            }}</v-icon>
                          </v-btn>
                          <v-btn
                            v-else-if="
                              props.item.payment_service === 'boletosimples' &&
                              props.item.transaction
                            "
                            v-on="on"
                            :href="
                              props.item.transaction &&
                              props.item.transaction.formats
                                ? props.item.transaction.formats.pdf
                                : ''
                            "
                            target="_blank"
                            class="mx-0"
                            icon
                          >
                            <v-icon color="grey">{{
                              "boleto" | formatPaymentTypeIcon
                            }}</v-icon>
                          </v-btn>
                          <v-btn
                            v-else-if="
                              props.item.payment_type === 'credit_card'
                            "
                            v-on="on"
                            class="mx-0"
                            icon
                          >
                            <v-icon color="grey">{{
                              props.item.payment_type | formatPaymentTypeIcon
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span v-if="props.item?.transaction?.pix_qr_code"
                          >Pix Copia e Cola</span
                        >
                        <span
                          v-else-if="props.item?.payment_type === 'credit_card'"
                          >Pagamento por Cartão de Crédito</span
                        >
                      </v-tooltip>
                    </td>
                    <td class="justify-center px-0">
                      <v-tooltip bottom v-if="props.item.invoice_url">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-if="props.item.invoice_url"
                            v-on="on"
                            :href="props.item.invoice_url"
                            target="_blank"
                            class="mx-0"
                            icon
                          >
                            <v-icon color="red" large>mdi-file-pdf</v-icon>
                          </v-btn>
                        </template>
                        <span>Demonstrativo da Fatura</span>
                      </v-tooltip>
                    </td>
                    <td class="justify-center px-0">
                      <v-tooltip bottom v-if="props.item.receipt_url">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            :href="props.item.receipt_url"
                            target="_blank"
                            class="mx-0"
                            icon
                          >
                            <v-icon color="orange" large>receipt_long</v-icon>
                          </v-btn>
                        </template>
                        <span>Recibo de Pagamento</span>
                      </v-tooltip>
                    </td>
                  </template>

                  <template v-slot:progress>
                    <v-progress-linear
                      color="blue"
                      indeterminate
                    ></v-progress-linear>
                  </template>

                  <template v-slot:pageText="props">
                    Linhas {{ props.pageStart }} - {{ props.pageStop }} de
                    {{ props.itemsLength }}
                  </template>

                  <template v-slot:no-data> Não há faturas </template>
                </v-data-table>

                <v-data-table
                  v-if="installmentsTable"
                  :headers="dealHeaders"
                  :items="debtBillings"
                  :search="search"
                  :total-items="12"
                  hide-actions
                  no-data-text="Não há acordos"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.consumer_unit }}</td>
                    <td class="text-xs-right">
                      R$
                      {{
                        props.item.negotiation
                          ? props.item.negotiation.total_deal
                          : props.item.total | formatCurrency
                      }}
                    </td>
                    <td class="text-xs-right">
                      {{ props.item.due_date | formatarDate }}
                    </td>
                    <td class="text-xs-right">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            :color="
                              props.item.status | formatStatusBillingColor
                            "
                          >
                            {{ props.item.status | formatStatus }}
                          </v-icon>
                        </template>
                        <span>{{
                          props.item.status | formatTransactionStatus
                        }}</span>
                      </v-tooltip>
                    </td>
                    <td class="justify-center px-0">
                      <v-tooltip
                        bottom
                        v-if="props.item?.transaction?.pix_qr_code"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="
                              copyPixCode(props.item.transaction.pix_qr_code)
                            "
                            v-on="on"
                            class="mx-0"
                            icon
                          >
                            <v-icon color="grey">{{
                              "pix_with_link" | formatPaymentTypeIcon
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span>Pix Copia e Cola</span>
                      </v-tooltip>
                      <v-tooltip
                        bottom
                        v-if="props.item?.transaction?.boleto_url"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            :href="props.item.transaction.boleto_url"
                            target="_blank"
                            class="mx-0"
                            icon
                          >
                            <v-icon color="grey">{{
                              props.item.transaction &&
                              props.item.transaction.payment_method
                                ? props.item.transaction.payment_method
                                : currentUser.payment_type |
                                  formatPaymentTypeIcon
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver boleto</span>
                      </v-tooltip>
                      <v-tooltip
                        bottom
                        v-else-if="props.item.payment_type === 'credit_card'"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" class="mx-0" icon>
                            <v-icon color="grey">
                              {{
                                props.item.payment_type | formatPaymentTypeIcon
                              }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Pagamento por Cartão de Crédito</span>
                      </v-tooltip>
                    </td>
                    <td class="justify-center px-0">
                      <v-tooltip bottom v-if="props.item.receipt_url">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            :href="props.item.receipt_url"
                            target="_blank"
                            class="mx-0"
                            icon
                          >
                            <v-icon color="orange" large>receipt_long</v-icon>
                          </v-btn>
                        </template>
                        <span>Recibo de Pagamento</span>
                      </v-tooltip>
                    </td>
                  </template>

                  <template v-slot:progress>
                    <v-progress-linear
                      color="blue"
                      indeterminate
                    ></v-progress-linear>
                  </template>

                  <template v-slot:pageText="props">
                    Linhas {{ props.pageStart }} - {{ props.pageStop }} de
                    {{ props.itemsLength }}
                  </template>

                  <template v-slot:no-data> Não há acordos </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-snackbar
              v-model="snackbar.value"
              :multi-line="snackbar.mode === 'multi-line'"
              :timeout="snackbar.timeout"
              :top="snackbar.top"
              :color="snackbar.color"
            >
              {{ snackbar.message }}
              <v-btn color="white" flat @click="snackbar.value = false"
                >Fechar</v-btn
              >
            </v-snackbar>
          </v-container>
        </v-layout>
      </v-flex>
      <v-dialog v-model="parcelDialog" max-width="800px" persistent lazy>
        <v-form ref="parcel" v-model="parcel_valid" lazy-validation>
          <v-card>
            <v-card-title class="headline grey lighten-2"
              >Renegociar</v-card-title
            >
            <v-card-text>
              Selecione a(s) fatura(s) e o número de parcelas desejado. O valor
              de cada parcela será adicionado nas próximas faturas do membro.
              <v-alert
                :value="true"
                type="warning"
                v-if="this.billings.filter((b) => b.unique_billing == true)"
              >
                A opção de negociação abrange exclusivamente os valores devidos
                à Juntos Energia. Para evitar interrupções no fornecimento e
                garantir a regularização completa, além do pagamento desse
                acordo específico, é essencial quitar separadamente os valores
                correspondentes à concessionária responsável.
              </v-alert>
              <v-autocomplete
                prepend-icon="flag"
                v-model="parcelBillings"
                :items="
                  billings.filter(
                    (b) =>
                      b.status != 'paid' &&
                      b.status != 'succeeded' &&
                      b.status != 'paga' &&
                      b.status != 'free' &&
                      b.status != 'refunded' &&
                      b.status != 'chargedback' &&
                      b.status != 'reprocessing' &&
                      b.status != 'in_queue' &&
                      b.status != 'negotiated' &&
                      b.status != 'parceled',
                  )
                "
                :item-text="selectText"
                no-data-text="Não há faturas para parcelar"
                return-object
                label="Faturas"
                :rules="parcelBillingsRule"
                multiple
                chips
                required
                @change="parcelSimulated = false"
              ></v-autocomplete>
              Tipo de cobrança:
              <v-flex>
                <v-radio-group
                  v-model="parcelChargeType"
                  row
                  required
                  :rules="[(v) => !!v || 'Informe o tipo de parcelamento.']"
                  @change="resetSimulatedParcels"
                >
                  <v-tooltip
                    bottom
                    v-if="
                      consumerUnit &&
                      consumerUnit.status !== 'canceling' &&
                      consumerUnit.status !== 'canceled' &&
                      consumerUnit.status !== 'interrupting' &&
                      consumerUnit.status !== 'interrupted' &&
                      !consumerUnit.unique_billing
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-radio
                        label="Próximas Faturas"
                        value="billing"
                        v-on="on"
                        :disabled="hasNegativationActive"
                      ></v-radio>
                    </template>
                    <div>
                      Parcelas serão cobradas nas próximas faturas geradas
                      conforme faturamento do membro.
                    </div>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-radio
                        label="Boleto(s) Avulso(s)"
                        value="debt_billing"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <div>
                      Parcelas serão cobradas de forma avulsa, com a primeira
                      com vencimento em 7 dias.
                    </div>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-radio
                        label="Pix Avulso(s)"
                        value="debt_billing_pix"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <div>
                      Parcelas serão cobradas de forma avulsa, com a primeira
                      com vencimento em 7 dias.
                    </div>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-radio
                        label="Cartão de Crédito"
                        value="credit_billing"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <div>
                      A negociação será cobrada pelo cartão de crédito à vista
                      ou parcelado.
                    </div>
                  </v-tooltip>
                </v-radio-group>
              </v-flex>
              <div
                v-if="parcelInstallments && parcelInstallments.length > 0"
                class="font-weight-bold"
              >
                Selecione o número de parcelas para realizar a negociação:
              </div>
              <v-radio-group
                v-model="parcelQuantity"
                :mandatory="false"
                hide-details
                column
                style="display: block"
                class="pt-0"
              >
                <v-data-table
                  :headers="headers_installments"
                  :items="parcelInstallments"
                  hide-actions
                  no-data-text="Calcule as parcelas!"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      color="blue"
                      indeterminate
                    ></v-progress-linear>
                  </template>
                  <template v-slot:items="props">
                    <td
                      v-if="props.item.passed"
                      :class="
                        props.item.num_installments === parcelQuantity
                          ? 'blue lighten-4'
                          : 'white'
                      "
                    >
                      <v-radio
                        class="body-1"
                        :label="props.item.num_installments + 'x'"
                        :value="props.item.num_installments"
                      ></v-radio>
                    </td>
                    <td v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small>warning</v-icon>
                          <span v-on="on" class="pl-2 grey--text">{{
                            props.item.reason
                          }}</span>
                        </template>
                        <span>
                          Não cumpre regras! Não é possível realizar esse
                          parcelamento com
                          {{ props.item.num_installments }} parcelas.</span
                        >
                      </v-tooltip>
                    </td>
                    <td
                      :class="
                        (!props.item.passed ? 'grey--text ' : '') +
                        (props.item.num_installments === parcelQuantity
                          ? 'blue lighten-4'
                          : 'white') +
                        ' text-xs-right font-weight-bold'
                      "
                    >
                      R$ {{ props.item.installments_value | formatCurrency }}
                    </td>
                    <td
                      :class="
                        (!props.item.passed ? 'grey--text ' : '') +
                        (props.item.num_installments === parcelQuantity
                          ? 'blue lighten-4'
                          : 'white') +
                        ' text-xs-right'
                      "
                    >
                      R$ {{ props.item.total_amount | formatCurrency }}
                    </td>
                  </template>
                  <template v-slot:no-data> Calcule as parcelas! </template>
                </v-data-table>
              </v-radio-group>
              <v-select
                v-if="parcelChargeType === 'credit_billing'"
                prepend-icon="credit_card"
                v-model="selectedCreditCard"
                :items="creditCardsData"
                no-data-text="Não há cartões cadastrados"
                label="Cartões"
                required
                :rules="[
                  (v) => !!v || 'Por favor selecione um cartão de crédito.',
                ]"
              >
                <template v-slot:selection="{ item }">
                  <img height="40px" :src="iconBrand(item)" /> **** **** ****
                  {{ item.last_digits }}
                </template>
                <template v-slot:item="{ item }">
                  <img height="40px" :src="iconBrand(item)" /> **** **** ****
                  {{ item.last_digits }}
                </template>
              </v-select>
              <v-layout
                row
                wrap
                v-if="
                  parcelChargeType === 'debt_billing' ||
                  parcelChargeType === 'debt_billing_pix'
                "
              >
                <v-dialog
                  ref="dateDialog"
                  v-model="modal"
                  :return-value.sync="parcelDueDate"
                  persistent
                  lazy
                  full-width
                  width="450px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="parcelDueDate"
                      label="Selecione a Data de Vencimento da 1a. Parcela"
                      prepend-icon="date_range"
                      readonly
                      v-on="on"
                      :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    dark
                    v-model="parcelDueDate"
                    scrollable
                    width="450px"
                    :min="new Date().toISOString()"
                    :max="maxDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dateDialog.save(parcelDueDate)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                flat
                @click="
                  parcelDialog = false;
                  parcelSimulated = false;
                "
              >
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="simulateParcel"
                :disabled="loadingChange || !parcel_valid"
                :loading="loadingChange"
              >
                Calcular
              </v-btn>
              <v-btn
                color="primary"
                flat
                @click="saveParcel"
                :disabled="loadingChange || !parcelSimulated"
                :loading="loadingChange"
              >
                Gerar parcelas
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>

    <Footer />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Footer from "../../components/members/Footer.vue";
import Header from "../../components/members/Header.vue";
import { rebilling, simulateAllParcel, parcel } from "../../services/billing";
import { saveAnalytics } from "../../services/save_analytics";
import firebase from "firebase";
import firestore from "../../firebase/firestore";
import { getCards } from "../../services/support/cards";

export default {
  components: { Footer, Header },

  data: () => ({
    id: null,
    search: "",
    valid: false,
    consumerUnit: null,
    parcelDialog: false,
    parcel_valid: false,
    parcelBillings: [],
    parcelSimulated: false,
    parcelChargeType: null,
    parcelPenalty: false,
    parcelInstallments: [],
    parcelQuantity: 2,
    selectedCreditCard: null,
    creditCardsData: [],
    parcelDueDate: "",
    modal: false,
    loadingChange: false,
    parcelBillingsRule: [
      (v) => {
        if (v.length >= 1) return true;
        else return "Selecione no mínimo 1 fatura.";
      },
    ],
    parcelInstallmentsRule: [
      (v) => {
        if (parseFloat(v) >= 50) return true;
        else return "Valor de cada parcela deve ser de no mínimo R$50,00";
      },
    ],
    headers_installments: [
      { text: "Parcela", value: "competence", sortable: false },
      {
        text: "Valor Parcela",
        value: "installments_value",
        align: "right",
        sortable: false,
      },
      {
        text: "Valor Total",
        value: "total_amount",
        align: "right",
        sortable: false,
      },
    ],
    headers: [
      {
        text: "Unidade Consumidora",
        align: "left",
        sortable: false,
        value: "consumer_unit",
        hide: "smAndDown",
      },
      { text: "Competência", value: "competence" },
      { text: "Saldo", value: "balance" },
      { text: "Valor", value: "total", align: "right" },
      { text: "Vencimento", value: "", align: "right", hide: "smAndDown" },
      { text: "Status", value: "status", align: "right" },
      { text: " ", value: "" },
      { text: "  ", value: "" },
    ],
    dealHeaders: [
      {
        text: "Unidade Consumidora",
        align: "left",
        sortable: false,
        value: "consumer_unit",
      },
      { text: "Valor", value: "total", align: "right" },
      { text: "Vencimento", value: "", align: "right", hide: "smAndDown" },
      { text: "Status", value: "status", align: "right" },
      { text: " ", value: "" },
      { text: "  ", value: "" },
    ],
    defaultCountry: "+55",
    uuid: "7a019269-e71f-45e9-a45d-26052967655a",
    company: "314586",

    has_consumer_units: false,
    has_billings: false,
    is_complete: false,
    query_string: null,
    billingTable: true,
    installmentsTable: false,
    snackbar: {
      timeout: 6000,
      value: false,
      message: "",
      color: "",
      top: false,
      botton: false,
      mode: "",
    },
    headerActive: true,
  }),

  async beforeMount() {
    if (this.consumer_units.length >= 1) {
      this.has_consumer_units = true;
    }
    if (this.billings.length >= 1) {
      this.has_billings = true;
    }

    this.id = this.$route.params.id;
    if (this.$route.query) this.query_string = this.$route.query;

    await this.anonymousLogin()
      .then(async () => {
        if (this.id) {
          await this.getUserByID(this.id)
            .then(() => {
              this.has_billings = true;
              this.has_consumer_units = true;
              this.is_complete = true;
            })
            .catch((err) => {
              console.error(err);
              this.error_start = "Não conseguiu identificar o usuario";

              this.has_billings = false;
              this.has_consumer_units = false;
              this.is_complete = true;
            });
        }
      })
      .catch((err) => {
        console.error(err);
        this.has_billings = false;
        this.has_consumer_units = false;
        this.is_complete = true;
      });
  },

  async mounted() {
    await this.getDebtBillingsByCustomerId(this.id);

    const customer_id = this?.billings[0]?.customer_id;

    const cards = (
      await firestore.collection("users").doc(customer_id).get()
    )?.data()?.cards;

    if (cards) {
      const cardsData = await getCards(cards);
      this.creditCardsData = cardsData.map((item) => {
        return {
          value: item.data.id,
          brand: item.data.brand,
          last_digits: item.data.last_digits,
        };
      });
    }
  },

  methods: {
    ...mapGetters(["hasNegativationActive"]),
    ...mapActions("members", [
      "getBillingsByUser",
      "getUserByID",
      "getBillingsByUserAndConsumerUnit",
      "anonymousLogin",
      "getInstallmentsByUC",
    ]),
    ...mapActions("installment", [
      "getDebtBillingsByCustomerId",
      "getInstallmentsOfAllGroups",
    ]),

    simulateParcel() {
      if (this.$refs["parcel"].validate()) {
        console.log("parcelBillings: ", this.parcelBillings);
        if (!this.parcelChargeType && this.parcelBillings.length <= 0) {
          this.showSnackBar(
            "Por favor selecione o tipo de cobrança.",
            "top",
            "orange",
          );
          return;
        }
        this.loadingChange = true;
        simulateAllParcel(
          this.parcelBillings.map((b) => b.id),
          this.parcelChargeType,
          this.parcelPenalty,
          this.parcelPenalty,
        )
          .then((res) => {
            console.log("res", res);
            this.parcelInstallments = res.data;
            this.parcelSimulated = true;
            this.loadingChange = false;
          })
          .catch((err) => {
            console.log("err: ", err);
            if (err.response) {
              console.log(err.response);
            }
            this.loadingChange = false;
          });
      }
    },

    async saveParcel() {
      if (!this.$refs["parcel"].validate()) {
        return false;
      }
      this.loadingChange = true;
      let removePenalty = false;
      let removeInterest = false;
      if (this.parcelQuantity === 1) {
        removePenalty = this.parcelPenalty;
        removeInterest = this.parcelPenalty;
        console.log("removePenalty: ", removePenalty);
        console.log("removePenalty", removeInterest);
      }
      await parcel(
        this.parcelBillings.map((b) => b.id),
        this.parcelQuantity,
        this.parcelChargeType,
        this.parcelDueDate,
        removePenalty,
        removeInterest,
        null,
        null,
        null,
        this.selectedCreditCard,
      )
        .then(() => {
          this.parcelDialog = false;
          this.loadingChange = false;
          this.parcelBillings = [];
          this.parcelSimulated = false;
          this.showSnackBar(
            "Pedido de parcelamento feito com sucesso!",
            "top",
            "green",
          );
          const analytics = {
            eventCategory: "BILLING",
            eventAction: "INSTALLED_INVOICE",
            eventLabel: "NEGOCIATED_" + this.parcelQuantity,
            user_id: this.currentUser.email,
            agent: this.currentUser.email,
            boleto: false,
            parcelQuantity: Number(this.parcelQuantity),
          };
          saveAnalytics(analytics);
          this.parcelQuantity = 2;
        })
        .catch((err) => {
          this.parcelDialog = false;
          this.loadingChange = false;
          const error = err.response.data
            ? err.response.data.error
            : err.message;
          const message = err.response ? error : err.message;
          console.error(message);
          this.showSnackBar(
            "Erro ao realizar parcelamento. " + message,
            "top",
            "red",
          );
        });
    },

    resetSimulatedParcels() {
      this.parcelInstallments = [];
      this.num_installment = null;
    },

    selectText(item) {
      return (
        item.competence +
        " — R$" +
        (item.total || 0).toFixed(2) +
        " — " +
        this.formatStatus(item)
      );
    },

    formatStatus(billing) {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() - 1);

      if (billing.status === "") return "xxx";
      else if (billing.status === "paid" || billing.status === "succeeded")
        return "Paga";
      else if (billing.status === "pending") return "Processar";
      else if (billing.status === "refused") return "Recusada";
      else if (billing.status === "pending_approval") return "Em Análise";
      else if (billing.status === "reprocessing") return "Reprocessando";
      else if (billing.status === "generating") return "Gerando";
      else if (billing.status === "opened") return "Aberto";
      else if (billing.status === "canceled") return "Expirado";
      else if (billing.status === "overdue") return "Atrasada";
      else if (billing.status === "generation_failed") return "Falha ao gerar";
      else if (billing.status === "validation_failed") return "Inválido";
      else if (billing.status === "in_queue") return "Programado";
      else if (billing.status === "error") return "Erro";
      else if (billing.status === "free") return "Abonado";
      else if (billing.status === "refunded") return "Reembolsado";
      else if (billing.status === "negotiated") return "Negociado";
      else if (billing.status === "parceled") return "Parcelado";
      else if (billing.status === "waiting_payment") return "Aberta";
      else if (billing.status === "free_pending") return "Pendente para Abono";
      else if (billing.status === "postponed")
        return "O valor da fatura será cobrado nas próximas faturas";
      else return billing.status;
    },

    async saveRebilling() {
      if (!this.$refs["rebilling"].validate()) {
        return false;
      }
      this.loadingChange = true;
      await rebilling(
        this.rebillingBillings.map((b) => b.id),
        this.rebillingMethod,
        this.rebillingDate,
        this.rebillingPenalty,
        this.rebillingInterest,
      )
        .then(() => {
          this.rebillingDialog = false;
          this.loadingChange = false;
          const analytics = {
            eventCategory: "BILLING",
            eventAction: "BILLING_REPROCESSED",
            eventLabel: "NEGOCIATED_" + this.rebillingMethod,
            user_id: this.currentUser.email,
            agent: this.currentUser.email,
            boleto: false,
          };
          saveAnalytics(analytics);
          this.showSnackBar(
            "Pedido de renegociação feito com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.rebillingDialog = false;
          this.loadingChange = false;
          this.showSnackBar("Erro ao fazer renegociação. " + err, "top", "red");
          console.error("------>", err);
        });
    },

    getBillings(user_id, consumer_unit) {
      let params = {
        customer_id: user_id,
        consumer_unit,
      };
      this.getBillingsByUserAndConsumerUnit(params);
    },

    downloadContracts(contract_url, id) {
      if (contract_url) {
        let url = "gs://enercred.appspot.com/" + contract_url;
        const resumeRef = firebase.storage().refFromURL(url);
        resumeRef
          .getDownloadURL()
          .then((url) => {
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = function () {
              const blob = xhr.response;
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "contrato-" + id;
              link.click();
              URL.revokeObjectURL(link.href);
            };
            xhr.open("GET", url);
            xhr.send();
          })
          .catch((error) => {
            switch (error.code) {
              case "storage/object-not-found":
                this.showSnackBar(
                  "Não foi encontrado nenhum contrato para este membro!",
                  "top",
                  "orange",
                );
                break;

              case "storage/unauthorized":
                this.showSnackBar(
                  "Não possui permissão para acessar esse contrato!",
                  "top",
                  "orange",
                );
                break;

              case "storage/canceled":
                this.showSnackBar(
                  "Erro ao fazer dowload do contrato!",
                  "top",
                  "orange",
                );
                break;

              case "storage/unknown":
                this.showSnackBar(
                  "Não foi encontrado nenhum contrato para este membro!",
                  "top",
                  "orange",
                );
                break;
              case "storage/invalid-argument":
                this.showSnackBar(
                  "Não foi encontrado nenhum contrato para este membro!",
                  "top",
                  "orange",
                );
                break;
              default:
                break;
            }
          });
      } else {
        this.showSnackBar(
          "Não foi encontrado nenhum contrato para este membro!",
          "top",
          "orange",
        );
      }
    },

    changeTables(aba) {
      if (aba === 1) {
        this.billingTable = true;
        this.installmentsTable = false;
      } else {
        this.billingTable = false;
        this.installmentsTable = true;
      }
    },

    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },

    copyPixCode(link) {
      navigator.clipboard.writeText(link);
      this.showSnackBar(
        "Código Pix copiado para área de transferência",
        "top",
        "green",
      );
    },

    changeActiveHeader() {
      this.headerActive = !this.headerActive;
    },
  },

  computed: {
    ...mapState("members", [
      "billings",
      "loading",
      "currentUser",
      "consumer_units",
      "consumer_unit",
    ]),
    ...mapState(["userId"]),
    ...mapGetters("members", [
      "overdueBillings",
      "overdueTotal",
      "overdueBillingsIds",
    ]),
    ...mapGetters("installment", [
      "installmentsGroups",
      "allInstallments",
      "debtBillings",
    ]),

    computedHeaders() {
      return this.headers.filter(
        (h) => !h.hide || !this.$vuetify.breakpoint[h.hide],
      );
    },

    contract_id() {
      if (!this.consumerUnit.contract_id) return "#";
      return (
        "https://painel.autentique.com.br/documentos/" +
        this.consumerUnit.contract_id
      );
    },

    maxDate() {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      return date.toISOString();
    },
  },

  watch: {
    consumer_unit(val) {
      this.consumerUnit = val;
    },

    installmentsGroups() {
      this.getInstallmentsOfAllGroups(this.installmentsGroups);
    },
  },
};
</script>

<style scoped lang="scss">
.headlineButton {
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;
  margin-top: 1em;
  margin-bottom: 1em;
}

.header {
  display: flex;
  gap: 20px;
}

.header_link {
  color: #525252;
  transition: all 0.4s ease;

  &:hover {
    color: #000000;
  }
}

.active {
  color: #252525;
  pointer-events: none;
  border-bottom: 3px solid #000;
}
</style>
